import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import DetailPage from './LatestDetailsPage'
import CommunicationPage from './Communication/Communication'
import {
  getBankMatchingData, getBankMatchingDataWithId, getNbfcMatchingDataWithId, getWorkflowApi, getWorkflowCountApi,
  SaveApplicationStatusApi, DisburseApplicationStatusApi, ApproveApplicationStatusApi, geLoanActivityApi,
  geLoanEmiApi, saveStickyNotes, getStickyNotes, CommunityLeadGetUserLoanApi
} from '../../CommunityActionCreator'
import SelectField from '../../../CommonComponents/SelectMUI'
import moment from 'moment'
import copy from 'copy-to-clipboard'
import Alerts from '../../../Popups/SidePopup';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import Routes from '../../../../Layout/Routes';
import Tooltip from '@mui/material/Tooltip';
import { approveCustomValidation } from '../../../Validations'
import AmountPopup from './DisbursePopup'
import ActivityPage from './Activity'
import EmiDetails from './EmiDetails';
import CrifPage from './CrifDetails'
// import Chats from './Chat/Chat'
import ApproveAmountPopup from './ApproveAmountPopup';
import AlertPopup from '../../../Popups/alert.mui'
import Document from './Document/DocumentDetails'
import Commission from './Commission';


import AdminComments from './AdminComments';
import GoogleSheets from './GoogleSheets';
import StickyNotes from './StickyNotes'
import Challenges from './Challenges';
// let rolesData = window.sessionStorage.getItem('rolesData');


const DetailMainPage = ({ leadPageHandlerPages, leadDetailData }) => {
  const [viewScreen, setViewScreen] = useState('detail')
  const location = useLocation();
  const [allStatus, setAllStatus] = useState([])
  const [status, setStatus] = useState('')
  const [amount, setAmount] = useState('')
  const [emi, setEmi] = useState('')
  const [popupState, setpopupState] = useState(false)
  const [approvePopupState, setApprovePopupState] = useState(false)
  const [alertPopupState, setalertPopupState] = useState(false)
  const [msg, setmsg] = useState()
  const [flag, setflag] = useState()
  const [approveDate, setApproveDate] = useState(new Date());
  const [repaymentDate, setrepaymentDate] = useState(new Date());
  const [disbursedDate, setdisbursedDate] = useState(new Date());
  const [copyPopup, setcopyPopup] = useState(false)
  const [stickyNotesToShow, setstickyNotesToShow] = useState(false)

  const [approveData, setapproveData] = useState({
    approvalType: '',
    penaltyFee: '',
    penaltyFeeType: '',
    rateOfInterest: '',
    typeOfInterestRate: '',
    processingFeeAtDisbursment: '',
    processingFee: '',
    processingFeeType: '',
  })
  const [filter, setFilter] = useState({
    lenderId: '',
    licenseId: '',
    type: ''
  })
  const [message, setMessage] = useState({})


  const [bankName, setbankName] = useState('')
  const [matchingData, setMatchingData] = useState([])
  const [matchingDiv, setMatchingDataDiv] = useState(false)

  const [nbfcName, setNbfcName] = useState('')
  const [matchingDataNbfc, setMatchingDataNbfc] = useState([])
  const [matchingDivNbfc, setMatchingDataDivNbfc] = useState(false)

  const [bankId, setbankId] = useState('')
  const [nbfcId, setNbfcId] = useState('')

  const [approvedAmount, setApprovedAmount] = useState(leadDetailData.rowData.loanStatus);
  const [validationMsg, setvalidationMsg] = useState({})
  const [validationMsgfirst, setvalidationMsgfirst] = useState()
  const [disableNbfc, setDisableNbfc] = useState(false)
  const [disableBank, setDisableBank] = useState(false)
  const [stickyData, setStickyData] = useState()

  const navigate = useNavigate();

  // GET_LOAN_DETAILS_BY_LOAN_ID

  const stickyHandler = (type, payload, notes) => {
    setStickyData(notes)
    console.log(type)
    if (type == 'add') {
      colorFunction()
    }

  }
  const stickyHandlerSave = (e) => {
    console.log(leadDetailData.rowData.loanId)
    if (e.keyCode === 13) {
      if (leadDetailData.rowData.loanId) {
        saveStickyNotes(leadDetailData.rowData.loanId, window.sessionStorage.getItem('emailId'), stickyData, callBack => {
          console.log(callBack)
        })
      }

    }

  }
  const leadPageHandler = (e) => {
    setViewScreen(e)
  }
  const close = () => {
    setpopupState(false)
  }
  const closeApprovePopup = () => {
    setApprovePopupState(false)
  }
  const getKeyByValue = (object, value) => {
    console.log(object, value)
    return (object).find(key =>
      object[key] === value
    );

  }
  useEffect(() => {

    console.log(leadDetailData.qrId, " qqqqqqqqqqq");
    if (window.sessionStorage.getItem('lenderId') !== 'null' && window.sessionStorage.getItem('lenderId') !== undefined) {
      setFilter({
        lenderId: window.sessionStorage.getItem('lenderId'),
        licenseId: '',
        type: 'LENDER'
      })
    } else {
      setFilter({
        lenderId: leadDetailData.rowData.lenderId,
        licenseId: '',
        type: 'LENDER'
      })
    }
    setAmount(leadDetailData.rowData.loanAmount)
    setStatus(leadDetailData.rowData.loanStatus)
    setEmi(leadDetailData.rowData.tenure)
    console.log(leadDetailData.rowData)
    setApproveDate(leadDetailData.rowData.date)
    getEmiHandler()
    getActivityHandler()
    getWorkflowCountApi(filter, count => {
      // if (rolesData && rolesData.includes("setStatus")) {
      getWorkflowApi(1, count, filter,
        callBack => {
          if (callBack.length > 0) {
            let arr = []
            callBack.forEach(element => {

              // if (element.currentStageName === "Approved" && rolesData && rolesData.includes('setStatusApproved')) {
              //     arr.push({ code: element.currentStage, name: element.currentStageName })
              // }
              // if (element.currentStageName === "Disbursed" && rolesData && rolesData.includes('setStatusDisbursed')) {
              //     arr.push({ code: element.currentStage, name: element.currentStageName })
              // }
              // if (element.currentStageName === "Paid" && rolesData && rolesData.includes('setStatusPaid')) {
              //     arr.push({ code: element.currentStage, name: element.currentStageName })
              // }
              if (element.currentStageName === "Approved") {
                arr.push({ code: element.currentStage, name: element.currentStageName })
              }
              if (element.currentStageName === "Disbursed") {
                arr.push({ code: element.currentStage, name: element.currentStageName })
              }
              if (element.currentStageName === "Paid") {
                arr.push({ code: element.currentStage, name: element.currentStageName })
              }
              if (element.currentStageName !== "Paid" && element.currentStageName !== "Disbursed" && element.currentStageName !== "Approved") {
                arr.push({ code: element.currentStage, name: element.currentStageName })
              }

            });
            setAllStatus(arr)
            Object.values(arr).map((data, i) => {
              if (data.name === leadDetailData.rowData.loanStatus) {
                setStatus(data.code)
              }
            })


          }
        },
        error => {

        })
      // }

    }, error => {

    })

    if (leadDetailData.cameFrom !== '' && leadDetailData.cameFrom !== null && leadDetailData.cameFrom !== undefined) {
      setViewScreen("logs")
    }

  }, [])
  const amountHandler = (e) => {
    setAmount(e.target.value)
  }

  const emiHandler = (e) => {
    setEmi(e.target.value)
  }
  const approveDateHandler = (e) => {
    setApproveDate(e)
  }
  const repaymentDateHandler = (e) => {
    setrepaymentDate(e)
  }
  const disburseDateHandler = (e) => {
    setdisbursedDate(e)
  }
  const NewCopy = (data) => {
    copy(data)
    setmsg('Copied!')
    setcopyPopup(true)
    removePopup()
  }
  const disburseHandler = (e) => {
    const data = {
      "loanId": leadDetailData.rowData.loanId,
      "date": moment(disbursedDate).format("DD-MM-YYYY"),
      "amount": approvedAmount
    }
    DisburseApplicationStatusApi(data, callBack => {
      close()
      setalertPopupState(true)
      setflag('success')
      setmsg('Status Changed Successfully!')
      removePopup()
    }, error => {
      close()
      setalertPopupState(true)
      setflag('success')
      setmsg('Status Changed Successfully!')
      removePopup()
    })
  }

  const bankNameHandler = (data) => {
    setbankName(data.bank_name)
    setbankId(data.bank_id)
    setMatchingDataDiv(false)
  }

  const nbfcNameHandler = (data) => {
    console.log(data)
    setNbfcName(data.nbfc_name)
    setNbfcId(data.nbfc_id)
    setMatchingDataDivNbfc(false)
  }

  const validation = (amount, emi, approveData, bankName, bankId, nbfcName, nbfcId) => {
    // if (amount && emi && approveData.approvalType !== '' && approveData.approvalType !== undefined) {
    if (amount === '' || amount === 'null' || amount === 'undefined' || amount === '0') {
      return {
        status: false,
        msg: 'Please enter Amount',
        field: 'amountHelp'
      }
    }
    if (emi === '' || emi === 'null' || emi === 'undefined' || emi === '0') {
      return {
        status: false,
        msg: 'Please enter Emi',
        field: 'emiHelp'
      }

    }

    if (bankName) {
      if (bankId === 'null' || bankId === '' || bankId === 'undefined') {
        return {
          status: false,
          msg: 'Please select bank from the list',
          field: 'bankHelp'
        }
      }

    }
    if (nbfcName) {
      if (nbfcId === 'null' || nbfcId === '' || nbfcId === 'undefined') {
        return {
          status: false,
          msg: 'Please enter nbfc from the list',
          field: 'nbfcHelp'
        }
      }

    }
    if (approveData.approvalType === '' || approveData.approvalType === 'null' || approveData.approvalType === 'undefined') {
      return {
        status: false,
        msg: 'Please select approval type',
        field: 'approvalHelp'
      }
    }
    else {
      return {
        status: true,
        msg: '',
        field: ''
      }
    }

  }


  const approvedHandler = (e) => {
    let check = true
    let valid = validation(amount, emi, approveData, bankName, bankId, nbfcName, nbfcId)
    console.log(valid, "  bfnscvk sjckfmkkcsf");
    if (valid.status) {
      setvalidationMsgfirst('')
      setMessage({})
      console.log(approveData.approvalType);
      if (approveData.approvalType === true) {
        let validationMsg = approveCustomValidation(approveData)
        console.log(validationMsg, 'validationMsg')
        check = validationMsg.status
        setvalidationMsg(validationMsg)
      }
      if (check) {
        const creditData = {
          "lenderId": window.sessionStorage.getItem('lenderId') === 'null' ? leadDetailData.rowData.lenderId : window.sessionStorage.getItem('lenderId'),
          "licenseId": ''
        }
        // getCreditAssessmentConfigApi(0, 1, creditData, callBack => {
        //     const configData = callBack[0];
        //     console.log(callBack)

        //     if (amount >= configData.minAmount && amount <= configData.maxAmount) {
        //         if (emi >= configData.minTenure && emi <= configData.maxTenure) {
        let data = ''
        if (approveData.approvalType === false) {
          data = {
            "loanId": leadDetailData.rowData.loanId,
            "approveDate": moment(approveDate).format("DD-MM-YYYY"),
            "empId": window.sessionStorage.getItem('emailId'),
            "loanEmi": emi,
            "loanApproveAmount": amount,
            "approvalBankName": bankName ? bankName : nbfcName,
            "approvalBankId": bankId ? bankId : nbfcId,
            // "loanPayBackDate": moment(repaymentDate).format("DD-MM-YYYY"),
            "customCalculation": approveData.approvalType
          }
        }
        { console.log(approveData, "  approveData"); }
        if (approveData.approvalType === true) {
          data = {
            "loanId": leadDetailData.rowData.loanId,
            "approveDate": moment(approveDate).format("DD-MM-YYYY"),
            "empId": window.sessionStorage.getItem('emailId'),
            "loanEmi": emi,
            "loanApproveAmount": amount,
            // "loanPayBackDate": moment(repaymentDate).format("DD-MM-YYYY"),
            "penaltyFee": approveData.penaltyFee ? Number(approveData.penaltyFee) : "",
            "penaltyFeeType": approveData.penaltyFeeType ? approveData.penaltyFeeType : '',
            "rateOfInterest": approveData.rateOfInterest ? Number(approveData.rateOfInterest) : '',
            "typeOfInterestRate": approveData.typeOfInterestRate ? approveData.typeOfInterestRate : "",
            "processingFeeAtDisbursment": approveData.processingFeeAtDisbursment ? approveData.processingFeeAtDisbursment : "",
            "processingFee": approveData.processingFee ? Number(approveData.processingFee) : "",
            "processingFreeType": approveData.processingFeeType ? approveData.processingFeeType : "",
            "customCalculation": approveData.approvalType,
            "approvalBankName": bankName ? bankName : nbfcName,
            "approvalBankId": bankId ? bankId : nbfcId
          }
        }
        console.log(data, 'data')
        ApproveApplicationStatusApi(data, callBack => {
          if (callBack === 'success') {
            closeApprovePopup()
            setalertPopupState(true)
            setflag('success')
            setmsg('Status Changed Successfully!')
            removePopup()
          } else {
            closeApprovePopup()
            setalertPopupState(true)
            setflag('failure')
            setmsg('Please Try Again Later!')
            removePopup()
          }
        }, error => {

        })


        //         } else {
        //             setalertPopupState(true)
        //             setflag('failure')
        //             setmsg('EMI Should be less than or equals to ' + configData.maxTenure + ' or greater than or equals to ' + configData.minTenure)
        //             removePopup()
        //         }
        //     } else {
        //         setalertPopupState(true)
        //         setflag('failure')
        //         setmsg('Amount Should be less than or equals to ' + configData.maxAmount + ' or greater than or equals to ' + configData.minAmount)
        //         removePopup()
        //     }

        // }, error => {

        // })
      }
      // }
    } else {
      // setvalidationMsgfirst('Enter all details')
      setMessage(valid)
    }

  }
  const getEmiHandler = () => {
    geLoanEmiApi(leadDetailData.rowData.loanId, callBack => {

    }, error => {

    })
  }

  const getActivityHandler = () => {
    geLoanActivityApi(leadDetailData.rowData.loanId, callBack => {

    }, error => {

    })
  }

  const statusChange = (e) => {
    setStatus(e)
    if (e === 204) {
      // const data = {
      //     "loanId": leadDetailData.rowData.loanId,
      //     "approveDate": moment(new Date()).format("DD-MM-YYYY"),
      //     "empId": window.sessionStorage.getItem('emailId'),
      //     "loanEmi": leadDetailData.rowData.tenure,
      //     "loanApproveAmount": leadDetailData.rowData.loanAmount
      // }
      // ApproveApplicationStatusApi(data, callBack => {
      //     if (callBack === 'success') {
      //         setalertPopupState(true)
      //         setflag('success')
      //         setmsg('Status Changed Successfully!')
      //         removePopup()
      //     } else {
      //         setalertPopupState(true)
      //         setflag('failure')
      //         setmsg('Please Try Again Later!')
      //         removePopup()
      //     }

      // }, error => {

      // })
      setApprovePopupState(true);
    } else if (e === 205) {
      getLoanData(leadDetailData.rowData.loanId)
      setpopupState(true)
      // const data = {
      //     "loanId": leadDetailData.rowData.loanId,
      //     "date": moment(new Date()).format("DD-MM-YYYY"),
      // }
      // DisburseApplicationStatusApi(data, amount, callBack => {

      // }, error => {

      // })
    } else {
      if (e !== '' && e !== null && e !== undefined) {
        SaveApplicationStatusApi(leadDetailData.rowData.loanId, e, callBack => {
          if (callBack === 'success') {
            setalertPopupState(true)
            setflag('success')
            setmsg('Status Changed Successfully!')
            removePopup()
            getLoanData(leadDetailData.rowData.loanId)

          } else {
            setalertPopupState(true)
            closeApprovePopup()
            setflag('failure')
            setmsg('Please Try Again Later!')
            removePopup()
          }
        }, error => {
          closeApprovePopup()
        }
        )
      }
    }
  }

  const getLoanData = (loanId) => {
    CommunityLeadGetUserLoanApi(loanId, callBack => {
      setApprovedAmount(callBack.approvedAmount)
    }, error => {

    })
  }


  const removePopup = () => {
    setTimeout(
      function () {
        setalertPopupState(false)
      }.bind(this),
      5000
    );
  }
  const approveDataHandlernew = (e, type) => {
    let changeData = Object.assign({}, approveData)
    setMessage({})
    if (type === 'rateOfInterest' || type === 'penaltyFee' || type === 'processingFee') {
      console.log("dataaaa in roi ", e.target.value);

      changeData[type] = e.target.value
    }
    else if (type === 'bankName') {
      setbankId('')
      setNbfcId('')
      getBankMatchingDataWithId(e.target.value, callBack => {
        setMatchingData(callBack.data)
        setMatchingDataDiv(true)
      })
      setbankName(e.target.value)
      setDisableNbfc(true)
      if (e.target.value === '') {
        setDisableNbfc(false)
        setMessage({})
      }
    }
    else if (type === 'nbfcName') {
      setbankId('')
      setNbfcId('')
      getNbfcMatchingDataWithId(e.target.value, callBack => {
        setMatchingDataNbfc(callBack.data)
        setMatchingDataDivNbfc(true)
      })
      setNbfcName(e.target.value)
      setDisableBank(true)
      if (e.target.value === '') {
        setDisableBank(false)
        setMessage({})

      }
    }
    else if (type !== 'rateOfInterest' || type !== 'penaltyFee' || type !== 'processingFee') {
      console.log("dataaaa ", e);
      changeData[type] = e
    }
    setapproveData(changeData)
  }
  const BackButton = () => {
    leadPageHandlerPages("communityLeads", "")
    // if (leadDetailData.communityId && leadDetailData.communityId.communityId) {
    //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: leadDetailData.rowData, page: 'communityLeads' } })
    // }
    // if (leadDetailData.qrId) {
    //     let data = leadDetailData.rowData;
    //     data.qrId = leadDetailData.qrId;
    //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
    // }
    // else if (leadDetailData.communityId) {
    //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: leadDetailData.rowData, page: 'communityLeads' } })
    // }
    // else if (window.location.href.includes('lender')) {
    //     navigate(Routes.LENDER_ALL_LEADS)
    // }
    // else if (window.location.href.includes('admin')) {
    //     navigate(Routes.SUPER_ADMIN_ALL_LEADS)
    // }

    // else if (window.location.href.includes('community')) {
    //     navigate(Routes.COMMUNITY_ALL_LEADS)
    // }
  }

  const colorFunction = () => {
    setTimeout(
      function () {
        getcolor()
      }.bind(this),
      500
    );
  }

  const openStickyNotes = (type) => {
    console.log(type)
    if (type === 'open') {
      colorFunction()

      getStickyNotes(leadDetailData.rowData.loanId, callBack => {
        if (callBack && callBack?.length > 0) {
          window.localStorage.setItem('react-sticky-notes', JSON.stringify(callBack))
          setstickyNotesToShow(true)

        } else {
          window.localStorage.setItem('react-sticky-notes', '')

          setstickyNotesToShow(false)

        }


      })

    } else {
      setstickyNotesToShow(false)

    }
  }
  const getcolor = () => {
    let color = document.getElementsByClassName('rs-notes--header')
    let header = document.getElementsByClassName('rs-notes--navbar__item')
    let bodyColor = document.getElementsByClassName('rs-notes--note__body')
    Object.entries(color).map((data, i) => {
      let splitedData = data[1].style.backgroundColor.split(',')
      let el = data[1]
      let first = (splitedData[0]).split('(')
      let last = splitedData[2].split(')')
      console.log(first)
      let r = (first[1] < 80 ? 40 : first[1] > 100 ? 100 : first[1])
      let g = Number(splitedData[1] < 80 ? 40 : splitedData[1] > 100 ? 4 : splitedData[1])
      let b = (last[0] < 80 ? 40 : last[0] > 100 ? 100 : last[0])
      console.log('rgb(' + r + ',' + g + ',' + b + ')')
      el.style.background = 'rgb(' + r + ',' + g + ',' + b + ',' + 0.6 + ')'
      // }
    })
    Object.entries(header).map((data, i) => {
      let splitedData = data[1].style.backgroundColor.split(',')
      let first = (splitedData[0]).split('(')
      let last = splitedData[2].split(')')
      console.log(first)
      let r = (first[1] < 80 ? 40 : first[1] > 100 ? 100 : first[1])
      let g = Number(splitedData[1] < 80 ? 40 : splitedData[1] > 100 ? 4 : splitedData[1])
      let b = (last[0] < 80 ? 40 : last[0] > 100 ? 100 : last[0])
      let el = data[1]
      el.style.background = 'rgb(' + r + ',' + g + ',' + b + ',' + 0.6 + ')'

      // }
    })
    // Object.entries(bodyColor).map((data, i) => {
    //     console.log(data[1].style.backgroundColor.split(','))
    //     let splitedData = data[1].style.backgroundColor.split(',')
    //     console.log(splitedData[0] + ',124,' + splitedData[1] + ')')
    //     let el = data[1]
    //     el.style.background = splitedData[0]  + splitedData[1] + ',124)'
    //     // }
    // })

  }
  return (
    <div className='container-fluid full-height'>
      <Tooltip title='Back'>
        <ArrowBackIcon onClick={() => BackButton()} style={{ marginBottom: '20px', color: '#000', cursor: 'pointer' ,fontSize:'20px'}} />
      </Tooltip>
      <div className='row'>
        <div className='col-sm-4 col-xs-12'>
          <h3 className='text-color mb-3'>  Lead Name:<b> {leadDetailData.rowData.name}</b></h3>
        </div>
      </div>
      {/* {window.location.href.includes('/admin') ? */}
      {/* <div className='page-wrapper' onClick={() => openStickyNotes('open')}>
        <i className='fa fa-bars'></i>
      </div> */}
      {/* : ""} */}


      <div className='row'>

        <div className="edit-profile-menu col-xs-12">
          <div className="btn-group-tab">
            {/* {(rolesData && rolesData.includes("loanDetails") && (window.location.href.includes('lender') || window.location.href.includes('admin'))) ?
                            <div>
                                <button className={viewScreen === 'detail' ? 'active' : ''} onClick={e => leadPageHandler('detail')}>User Details</button>
                            </div>
                            : window.location.href.includes('community') ? <div>
                                <button className={viewScreen === 'detail' ? 'active' : ''} onClick={e => leadPageHandler('detail')}>User Details</button>
                            </div> : ""} */}
            <div>
              <button className={viewScreen === 'detail' ? 'active' : ''} onClick={e => leadPageHandler('detail')}>User Details</button>
            </div>
            <div>
              <button className={viewScreen === 'Documents' ? 'active' : ''} onClick={e => leadPageHandler('Documents')}>Documents </button>
            </div>
            <div>
              <button className={viewScreen === 'communication' ? 'active' : ''} onClick={e => leadPageHandler('communication')}>Communication  </button>
            </div>
            {/* <div>
                        <button className={viewScreen === 'crif' ? 'active' : ''} onClick={e => leadPageHandler('crif')}>Crif </button>
                    </div> */}

            {/* {rolesData && rolesData.includes("activity") && (window.location.href.includes('lender') || window.location.href.includes('admin')) ?
                            <div>
                                <button className={viewScreen === 'activity' ? 'active' : ''} onClick={e => leadPageHandler('activity')}>Activity </button>
                            </div> : window.location.href.includes('community') ? <div>
                                <button className={viewScreen === 'activity' ? 'active' : ''} onClick={e => leadPageHandler('activity')}>Activity </button>
                            </div> : ""} */}
            <div>
              <button className={viewScreen === 'activity' ? 'active' : ''} onClick={e => leadPageHandler('activity')}>Activity </button>
            </div>
            {/* {rolesData && rolesData.includes("emiDetails") && window.location.href.includes('lender') || window.location.href.includes('admin') ?
                            <div>
                                <button className={viewScreen === 'emiDetails' ? 'active' : ''} onClick={e => leadPageHandler('emiDetails')}>Emi Details </button>
                            </div>
                            : window.location.href.includes('community') ?
                                <div>
                                    <button className={viewScreen === 'emiDetails' ? 'active' : ''} onClick={e => leadPageHandler('emiDetails')}>Emi Details </button>
                                </div>
                                : ""} */}
            <div>
              <button className={viewScreen === 'emiDetails' ? 'active' : ''} onClick={e => leadPageHandler('emiDetails')}>Emi Details </button>
            </div>
            {/* {rolesData && rolesData.includes("logs") && window.location.href.includes('lender') || window.location.href.includes('admin') ?
                            <div>
                                <button className={viewScreen === 'logs' ? 'active' : ''} onClick={e => leadPageHandler('logs')}>Comments </button>
                            </div>
                            : window.location.href.includes('community') ?
                                <div>
                                    <button className={viewScreen === 'logs' ? 'active' : ''} onClick={e => leadPageHandler('logs')}>Comments </button>
                                </div>
                                : ""} */}
            <div>
              <button className={viewScreen === 'logs' ? 'active' : ''} onClick={e => leadPageHandler('logs')}>Comments </button>
            </div>
            {/* {rolesData && rolesData.includes("logs") ? */}
            <div>
              <button className={viewScreen === 'commission' ? 'active' : ''} onClick={e => leadPageHandler('commission')}>Commission</button>
            </div>
            {/* {window.location.href.includes('/admin/leadDetail') ? */}
            <div>
              <button className={viewScreen === 'challenge' ? 'active' : ''} onClick={e => leadPageHandler('challenge')}>Challenges</button>
            </div>

            {/* : ""} */}
            {<div>
              <button className={viewScreen === 'googleSheets' ? 'active' : ''} onClick={e => leadPageHandler('googleSheets')}>Sheets</button>
            </div>}
            {/* {rolesData && rolesData.includes("setStatus") ? */}
            <div>
              <button className={viewScreen === 'action' ? 'active' : ''} onClick={e => leadPageHandler('action')}>Action </button>
            </div>
            {/* : ""} */}

          </div>
        </div>
      </div>

      <div className='row full-height' style={{marginTop:'15px'}}>
        <div className='col-sm-12 col-xs-12 mt-2'>
          {stickyNotesToShow ?
            <StickyNotes
              openStickyNotes={openStickyNotes}
              stickyHandler={stickyHandler}
              stickyHandlerSave={stickyHandlerSave}
            />
            : ""}
          {viewScreen === 'detail' ?
            <DetailPage
              rowData={leadDetailData.rowData}
            />
            : viewScreen === 'communication' ?
              <CommunicationPage
                rowData={leadDetailData.rowData}
                loginType="LENDER"
              />
              : viewScreen === 'activity' ?
                <ActivityPage
                  rowData={leadDetailData.rowData}
                  loginType="LENDER"
                />
                : viewScreen === 'emiDetails' ?
                  <EmiDetails
                    rowData={leadDetailData.rowData}
                    loginType="LENDER"
                  />
                  : viewScreen === 'crif' ?
                    <CrifPage
                      rowData={leadDetailData.rowData}
                      loginType="LENDER"
                    />
                    // : viewScreen === 'logs' && !window.location.href.includes('/admin/leadDetail') ?

                    //     <Chats
                    //         rowData={leadDetailData.rowData}
                    //         loginType="LENDER"
                    //     />
                    : viewScreen === 'logs' ?

                      <AdminComments
                        rowData={leadDetailData.rowData}
                        loginType="LENDER"
                      />
                      : viewScreen === 'Documents' ?
                        <Document
                          rowData={leadDetailData.rowData}
                        />

                        : viewScreen === 'challenge' ?
                          <Challenges
                            rowData={leadDetailData.rowData}
                          />
                          : viewScreen === 'commission' ?
                            <Commission
                              rowData={leadDetailData.rowData}
                            /> : viewScreen === 'googleSheets' ?
                              <GoogleSheets
                                rowData={leadDetailData.rowData}
                              />
                              : viewScreen === 'action' ?
                                <div>

                                  {/* {rolesData && rolesData.includes("setStatus") ? */}
                                  <div style={{ width: '27%', marginBottom: '30px' }}>
                                    <SelectField
                                      label={'Set Status'}
                                      // label={status} 
                                      onChange={e => statusChange(e)}
                                      id="statusId"
                                      value={status}
                                      name="statusId"
                                      data={allStatus}
                                      size={'small'}
                                    />
                                  </div>
                                  {/* : console.log("Roleee", rolesData)} */}
                                </div>
                                : null}
        </div>
        {popupState ?
          <AmountPopup close={close} amount={approvedAmount} amountHandler={amountHandler} disburseHandler={disburseHandler} disburseDate={disbursedDate} disburseDateHandler={disburseDateHandler} />
          : ""}
        {approvePopupState ?
          <ApproveAmountPopup
            validationMsgfirst={validationMsgfirst}
            validationMsg={validationMsg}
            approveData={approveData}
            approveDataHandlernew={approveDataHandlernew}
            close={closeApprovePopup}
            amount={amount} emi={emi}
            amountHandler={amountHandler}
            approveHandler={approvedHandler}
            emiHandler={emiHandler}
            bankNameHandler={bankNameHandler}
            bankName={bankName}
            nbfcName={nbfcName}
            matchingData={matchingData}
            matchingDiv={matchingDiv}
            matchingDataNbfc={matchingDataNbfc}
            matchingDivNbfc={matchingDivNbfc}
            nbfcNameHandler={nbfcNameHandler}
            disableBank={disableBank}
            disableNbfc={disableNbfc}
            approveDate={approveDate}
            approveDateHandler={approveDateHandler}
            repaymentDate={repaymentDate}
            repaymentDateHandler={repaymentDateHandler}
            message={message}
          />
          : ""}
        {alertPopupState ?
          <AlertPopup msg={msg} flag={flag} />
          : ""}

        {
          copyPopup ?
            <Alerts msg={msg} />
            : ""
        }

      </div>
    </div>
    // </div >

  )
}

export default DetailMainPage;